import { cn } from '@crm/ui';
import { CalendarRange, ClipboardCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useOpenSection } from '@/app/layouts';
import { SCHEDULE_ROUTES } from '../api';

const TABS = [
  { key: 'agenda', label: 'Agendamentos', icon: CalendarRange, to: SCHEDULE_ROUTES.AGENDA },
  {
    key: 'desk',
    label: 'Atendimentos',
    icon: ClipboardCheck,
    to: SCHEDULE_ROUTES.SERVICE_DESK,
  },
] as const;

/**
 * As duas telas da operacao lado a lado. No celular o botao de troca ficava
 * espremido entre as acoes do cabecalho; como aba ele diz onde se esta e para
 * onde da para ir com um toque.
 */
export function OperationTabs({ current }: { current: 'agenda' | 'desk' }) {
  const { closeAfterNavigate } = useOpenSection();

  return (
    // Abas de pagina: a ativa e sublinhada, as duas dividem a largura e a
    // linha de baixo separa o cabecalho do conteudo.
    <div className="sticky top-16 z-30 -mx-3 -mt-4 mb-4 flex border-b border-black/[0.03] bg-background shadow-[0_2px_6px_-2px_rgba(15,23,42,0.10)] sm:hidden dark:border-white/[0.06]">
      {TABS.map((tab) => {
        const active = tab.key === current;

        return (
          <Link
            key={tab.key}
            to={tab.to}
            aria-current={active ? 'page' : undefined}
            onClick={() => closeAfterNavigate(tab.to)}
            className={cn(
              'flex flex-1 items-center justify-center gap-2 border-b-2 px-4 py-2.5 text-sm transition-colors',
              active
                ? 'border-primary font-semibold text-primary'
                : 'border-transparent text-muted-foreground',
            )}
          >
            <tab.icon className="h-4 w-4" />
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
}
